module.exports = __webpack_public_path__ + "img/iphone8screenshot3.3eae1f7f.png";